import type { Action } from '@estandarte/engine';

type A<T extends Action['type']> = Extract<Action, { type: T }>;

export const ofType = <T extends Action['type']>(legal: Action[], type: T) =>
  legal.filter((a) => a.type === type) as A<T>[];
